module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Home/Wood-horse-a140626495d8cbf9d1296d6b14ce2ca6.svg";